export class MaintenanceTaskTransformer {
  static transform(obj) {
    let maintenanceTask = { ...obj.attributes };
    maintenanceTask.id = obj.id;
    return maintenanceTask;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/maintenanceTasks/maintenanceTask.transformer.js